/* GASSISA
=======================================================================================
 * Descripción: Actions del módulo de Centro de Costos
 * Historial de cambios:
 * ---------------------------------------------------------------------------------------
 *    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
 * ---------------------------------------------------------------------------------------
 *      1       | 13/05/2026 | Lic. José Luis Aragón Cervantes  | Creación
 *      2       | 13/05/2026 | Lic. José Luis Aragón Cervantes  | Agregar botones ofertas
 *      3       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en acciones críticas
 * ---------------------------------------------------------------------------------------
 */

import { Fragment } from "react";
import { IconButton, Tooltip } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UndoIcon from '@mui/icons-material/Undo';
import UpdateIcon from '@mui/icons-material/Update';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import DeleteIcon from '@mui/icons-material/Delete';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { useDoubleClickPrevention } from "../../hooks/useDoubleClickPrevention";

export default function MnuCentroCostosActions({
    onRegresar,
    onDeshacerCambios,
    onActualizarCostos,
    onOpenModalOferta,
    hayCambios,
    loading,
    listaArticulos = [],
    hayArticulosConOferta,
    onOpenTenantSync
}) {
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={onRegresar}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </Tooltip>
            {hayCambios && onDeshacerCambios && (
                <Tooltip title={"Deshacer cambios"}>
                    <IconButton onClick={() => executeWithProtection(onDeshacerCambios)} color="warning" disabled={isProcessing}>
                        <UndoIcon className="icon" /><p className="icon">Deshacer</p>
                    </IconButton>
                </Tooltip>
            )}
            {onActualizarCostos && (
            <Tooltip title={loading ? "Aplicando cambios..." : listaArticulos.length === 0 ? "Primero busca artículos" : "Aplicar costos a artículos visibles"}>
                     <span>
                         <IconButton onClick={() => executeWithProtection(onActualizarCostos)} disabled={isProcessing || loading || listaArticulos.length === 0}>
                            <UpdateIcon className="icon" /><p className="icon">Aplicar</p>
                        </IconButton>
                    </span>
                </Tooltip>
            )}
            {onOpenModalOferta && (
                <Tooltip title={loading ? "Procesando..." : hayArticulosConOferta ? "Eliminar ofertas de artículos visibles" : "Aplicar oferta a artículos visibles"}>
                    <span>
                        <IconButton
                            onClick={() => executeWithProtection(onOpenModalOferta)}
                            disabled={isProcessing || loading || listaArticulos.length === 0}
                            color={hayArticulosConOferta ? "error" : "primary"}
                        >
                            {hayArticulosConOferta ? (
                                <DeleteIcon className="icon" />
                            ) : (
                                <LocalOfferIcon className="icon" />
                            )}
                            <p className="icon">{hayArticulosConOferta ? "Eliminar Oferta" : "Aplicar Oferta"}</p>
                        </IconButton>
                    </span>
                </Tooltip>
            )}
            {onOpenTenantSync && (
                <Tooltip title={listaArticulos.length === 0 ? "Primero busca articulos" : "Sincronizar lista visible con otras tiendas"}>
                    <span>
                        <IconButton onClick={onOpenTenantSync} disabled={isProcessing || loading || listaArticulos.length === 0}>
                            <SyncAltIcon className="icon" /><p className="icon">Sincronizar</p>
                        </IconButton>
                    </span>
                </Tooltip>
            )}
        </Fragment>
    );
}
